import { createModal, showModal, closeModal } from './modals.js';
import { t } from '../../../shared/i18n/index.js';
import { escapeHtml } from '../../../engine/core/validation.js';

let choosing = null;
/** A shared, keyboard-accessible choice for every export surface. */
export function chooseExportOptions() {
  if (choosing) return Promise.resolve(null);
  choosing = (async () => {
    const previous = document.activeElement;
    document.querySelectorAll('#operation-progress [data-state="complete"]').forEach(card => card.remove());
    const id = 'map-export-options';
    document.getElementById(id)?.remove();
    const modal = createModal({ id, title: t('common.export'), content: `
      <p>${escapeHtml(t('vault.exportOptions.intro'))}</p>
      <div class="map-export-choices">
        <button type="button" data-export-choice="map"><strong>${escapeHtml(t('vault.exportOptions.mapOnly'))}</strong><span>${escapeHtml(t('vault.exportOptions.mapOnlyHint'))}</span></button>
        <button type="button" data-export-choice="attachments"><strong>${escapeHtml(t('vault.exportOptions.withAttachments'))}</strong><span>${escapeHtml(t('vault.exportOptions.withAttachmentsHint'))}</span></button>
      </div>
      <p class="map-export-privacy">${escapeHtml(t('vault.exportOptions.privacy'))}</p>` });
    modal.querySelectorAll('[data-export-choice]').forEach(button => button.addEventListener('click', () =>
      closeModal(id, { includeAttachments: button.dataset.exportChoice === 'attachments' })));
    try { return await showModal(modal); }
    finally { modal.remove(); previous?.isConnected && previous.focus(); choosing = null; }
  })();
  return choosing;
}
